/**
 * This service used to fetched data from API in different instance
 */

/**
 * Import required module for this service
 */
import moment from 'moment';
import axios from '../axios-config';
import store from '../store/store';

const fetchData = {
  /**
   * Get navigation url function
   */
  fetchNavUrl(requestParams) {
    /* eslint no-param-reassign: "error" */
    /**
     * get session id from vuex store to pass into request
     * Note: this code can be modifie to pass request along with session_id
     */
    return new Promise((resolve, reject) => {
      axios.post(requestParams.url, requestParams.data)
        .then((res) => {
          /**
           * set tab_buttons data into vuex store which is used in differnt places
           * button.js store used for action, mutation and getters for button actions
           */
          if (res && res.data) {
            store.dispatch('setButtonDataAction', res.data);
          }
          /**
           * resolve promised on successfull response
           */
          resolve(res);
        }).catch((error) => {
        /**
         * reject promised on error response
         */
          reject(error);
        });
    });
  },
  /**
   * This function used to get Search result from API
   * @param {*} requestParams search page form post params
   * retuns search API result
   */
  getSearchData(requestParams) {
    /**
     * Front end accepting date in MM/DD/YYYY format which need to convert
     * into YYYYMMDD format before passing to API
     * Used moment plugin to convert date into desire format
     */
    let tempDob = requestParams.dob;
    if (tempDob !== '') {
      tempDob = moment(tempDob, 'MM/DD/YYYY').format('YYYYMMDD');
    }
    return new Promise((resolve, reject) => {
      /**
       * Converted request params into API acceptable format
       */
      let inputEmail = '';
      let inputPhone = '';
      if (requestParams.ep) {
        if (requestParams.ep.indexOf('@') === -1) {
          inputPhone = requestParams.ep.replace(/-/g, '');
        }
        if (requestParams.ep.indexOf('@') !== -1) {
          inputEmail = requestParams.ep;
        }
      }
      axios.get('/autoquotes/search', {
        params: {
          firstname: requestParams.fname,
          lastname: requestParams.lname,
          phone: inputPhone,
          zipcode: requestParams.zip,
          dob: tempDob,
          email: inputEmail,
          productTypeIds: requestParams.productType,
        },
      }).then((res) => {
        /**
         * resolve promised on successfull response
         */
        resolve(res);
      }).catch((error) => {
        /**
         * reject promised on error response
         */
        reject(error);
      });
    });
  },
  /**
   * This function used to call getPageData in all pages.
   * This is get request with end point API url
   * @param {*} requestParams API URL which need to call
   * Returns entire page data with all nodes
   */
  getPageData(requestParams) {
    /* eslint-disable */
    return new Promise((resolve, reject) => {
      axios.get(requestParams.url)
        .then((res) => {
          /* eslint no-param-reassign: "error" */
          /**
           * From back end getting date in YYYYMMDD format which need to convert
           * into MM/DD/YYYY format before displaying on UI
           * Used moment plugin to convert date into desire format
           */
          if (res.data.fields) {
            for (let arrayCntResp = 0; arrayCntResp < res.data.fields.length; arrayCntResp += 1) {
              if (store.getters.getClearRequiredErrorFlag && res.data.fields[arrayCntResp].has_error 
                && res.data.fields[arrayCntResp].error !== '') {
                  res.data.fields[arrayCntResp].error = '';
                  res.data.fields[arrayCntResp].has_error = false; 
              }

              if (res.data.fields[arrayCntResp].field_type === 'date_mmyyyy') {
                res.data.fields[arrayCntResp].field_value = moment(res.data.fields[arrayCntResp].field_value, 'MMYYYY').format('MM/YYYY');
              }

              if (res.data.fields[arrayCntResp].field_type === 'date_long' || res.data.fields[arrayCntResp].field_type === 'date_short' || res.data.fields[arrayCntResp].field_type === 'date_long_pii') {
                res.data.fields[arrayCntResp].field_value = moment(res.data.fields[arrayCntResp].field_value, 'YYYYMMDD').format('MM/DD/YYYY');
              }
              /**
               * From back end getting false value if checkbox was uncheked
               * which need to make empty in order to disply checkbox as unchecked
               * on UI
               */
              if (res.data.fields[arrayCntResp].field_type === 'checkbox' && res.data.fields[arrayCntResp].field_value === 'false') {
                res.data.fields[arrayCntResp].field_value = '';
              }
              /** set annual mileage value in store. This is required if user choose to refresh browser */
              if (res.data.fields[arrayCntResp].group_id === 3 && res.data.fields[arrayCntResp].field_type === 'number_medium' && res.data.fields[arrayCntResp].field_value !== '') {
                // update incoming value of annual mileage into store
                store.state.annualCalc.calcs[res.data.fields[arrayCntResp].index].annualMileage = res.data.fields[arrayCntResp].field_value;
              }
              if (res.data.fields[arrayCntResp].group_id === 3 && res.data.fields[arrayCntResp].field_type === 'numberterm_miles') {
                // update incoming value of annual mileage into store
                store.state.annualCalc.calcs[res.data.fields[arrayCntResp].index].miles = res.data.fields[arrayCntResp].field_value;
              }
              if (res.data.fields[arrayCntResp].group_id === 3 && res.data.fields[arrayCntResp].field_type === 'numberterm_days') {
                // update incoming value of annual mileage into store
                store.state.annualCalc.calcs[res.data.fields[arrayCntResp].index].days = res.data.fields[arrayCntResp].field_value;
              }
            }
          }
          /**
           * set clear required error validation flag off
           */
          store.dispatch('setReqValidationFlag', false);
          /**
           * set tab_buttons data into vuex store which is used in differnt places
           * button.js store used for action, mutation and getters for button actions
           */
          store.dispatch('setButtonDataAction', res.data);
          /**
           * set quote_summary node data into vuex store which is used to display
           * quote summary information on UI
           * button.js store used for action, mutation and getters for setQuoteSummaryAction actions
           */
          store.dispatch('setQuoteSummaryAction', res.data);
          /**
           * set help script node data into vuex store which is used to display
           * Hel/Script section on UI
           * helptext.js store used for action, mutation and getters for setHelpTextAction actions
           */
          store.dispatch('setHelpTextAction', res.data.blurbs);
          /**
           * set pageName value into vuex store which is used to
           * pass in all formPost request to formPost API
           * quote.js store used for action, mutation and getters for setPageName actions
           */
          store.dispatch('setPageName', res.data.page_name);
          /**
           * resolve promised on successfull response
           */
          resolve(res);
        }).catch((error) => {
        /**
         * reject promised on error response
         */
          reject(error);
        });
    });
  },
  /**
   * This function used to get carriers data for carrier match page
   * @param {*} url carrier url with carrier id
   * returns carrier result node with all details.
   */
  getCarriersData(url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then((res) => {
        /**
         * resolve promised on successfull response
         */
          resolve(res);
        }).catch((error) => {
        /**
         * reject promised on error response
         */
          reject(error);
        });
    });
  },
  /**
   * This function used to get navigation data of RC2 flow
   * @param {*} url carrier url with carrier id
   * returns carrier result node with all details.
   */
  getNavigationData(url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then((res) => {
        /**
         * resolve promised on successfull response
         */
          resolve(res);
        }).catch((error) => {
        /**
         * reject promised on error response
         */
          reject(error);
        });
    });
  },
  getDashboard(url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
};
/**
 * export service to used by different components
 */
export default fetchData;



// WEBPACK FOOTER //
// ./src/services/fetchData.js